import { RaidSeasonViewer } from '../shared/RaidSeasonViewer.jsx';

export function MobileRaidSeason() {
  return <RaidSeasonViewer mobile />;
}
